import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=d1f823a8&"
import script from "./PaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f823a8')) {
      api.createRecord('d1f823a8', component.options)
    } else {
      api.reload('d1f823a8', component.options)
    }
    module.hot.accept("./PaymentMethod.vue?vue&type=template&id=d1f823a8&", function () {
      api.rerender('d1f823a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/PaymentMethod.vue"
export default component.exports